import { useQuery } from "@tanstack/react-query";
import { isEcgDeviceOffline } from "lib/isEcgDeviceOffline";
import { useAPIClient } from "render/context/APIContext";
import { applySignal } from "./applySignal";

export function useECGDeviceQuery(pointer: {
  patientId: string;
  visitId: string;
}) {
  const api = useAPIClient();
  return useQuery({
    queryKey: ["ecg", pointer.patientId, pointer.visitId],
    queryFn: ({ signal }) => {
      const getDeviceReq = api.ecg.getDevice(pointer);
      applySignal(getDeviceReq, signal);

      return getDeviceReq.result;
    },
    // An offline device stays offline for longer than a retry burst, so the
    // operator gets the offline state at once and retries when it is back.
    retry: (count, error) => !isEcgDeviceOffline(error) && count < 3,
  });
}
